exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.main {\n  position: relative;\n  height: 100%;\n}\n.main .container {\n  height: 100%;\n  overflow-y: auto;\n}\n.main .weui-tabbar {\n  height: 1.306667rem /* 98/75 */;\n}\n.main .weui-tabbar .weui-tabbar__item {\n  text-decoration: none;\n}\n.main .weui-tabbar .weui-tabbar__item .weui-tabbar__icon {\n  width: 0.666667rem;\n  height: 0.666667rem;\n  padding: 0;\n}\n.main .weui-tabbar .weui-tabbar__item .weui-tabbar__label {\n  font-size: 0.32rem /* 24/75 */;\n}\n.main .weui-tabbar .weui-bar__item_on .weui-tabbar__label {\n  color: #2489ff;\n}\n.main .weui-tabbar:before {\n  border-top: 1px solid #ccc;\n}\n", ""]);

// exports
